import { useTribalContext } from '@/context/tribal';
import type { PropsWithChildren, ReactNode } from 'react';

interface SuperscriptProps {
  children?: React.ReactNode
}

export default ({ children }: SuperscriptProps) => {
  const { contentManager } = useTribalContext();
  return <sup>{children ?? contentManager.get('prices-superscript')}</sup>;
};
